import type { AxiosResponse } from 'axios';

import { API } from '@/api';
import { axiosInstance } from '@/utils/fetcher';

export interface ProcessorOption {
  key: number;
  value: string;
}

export const getProcessorListAPI = () => {
  return axiosInstance.request({
    method: 'get',
    url: `${API.LOSS_AND_DAMAGE}/GetClaimProcessor`,
  });
};

export type ProcessorListResponse = ProcessorOption[];

export const fetchProcessorList = async (): Promise<ProcessorListResponse> => {
  const response: AxiosResponse<ProcessorListResponse> = await getProcessorListAPI();
  return response.data;
};
